export default __webpack_public_path__ + "static/media/canine-II.f9b32601.png";